/**
 * Kill switch feature gate. When off, the launcher renders nothing and the TAP
 * traits are never fetched.
 */
export const KILL_SWITCH = 'rovo_reintroduction_modal';

/**
 * TAP (Traits And Personalization) user-level trait: truthy when the user HAS
 * sent at least one Rovo chat message.
 */
export const TRAIT_HAS_SENT_ROVO_CHAT_MESSAGE = 'segment_has_sent_rovo_chat_message_aaid';

/**
 * TAP user-level trait: truthy when the user is a Rovo chat monthly active user
 * (i.e. NOT dormant).
 */
export const TRAIT_IS_ROVO_CHAT_MAU = 'is_rovo_chat_mau';

/**
 * Upper bound on how long we wait for the TAP traits fetch before giving up. If
 * TAP is slow or unavailable we treat the user as not eligible rather than
 * blocking on the request — the modal simply does not show this session.
 */
export const TRAITS_FETCH_TIMEOUT_MS = 3000;

/**
 * Growth initiative used to attribute the modal's analytics events.
 * TODO: confirm the owning team's growth initiative before rollout.
 */
export const GROWTH_INITIATIVE = 'ai-mate';

/**
 * localStorage key used to ensure the modal is shown at most once per browser.
 */
export const DISMISSED_STORAGE_KEY = 'rovo-reintroduction-modal.dismissed';

/** Source tag attached to the rovo-triggers `chat-new` event. */
export const CHAT_OPEN_SOURCE = 'rovo-reintroduction-modal';
